import React from 'react';
import { Tag, Text } from 'src/@vymo/ui/atoms';
import TextArea from 'src/@vymo/ui/atoms/textArea';
import Accordion from 'src/@vymo/ui/blocks/accordion';
import { DETAIL_SECTIONS, getPayloadLines } from './constants';
import { formatTrackerPayload, getDisplayValue } from './queries';
import { PlaybookTrackerResultRowProps } from './types';
import styles from './index.module.scss';

function PlaybookTrackerResultRow({ row }: PlaybookTrackerResultRowProps) {
  const formattedInput =
    typeof row.input !== 'undefined' && row.input !== null
      ? formatTrackerPayload(row.input)
      : null;

  return (
    <Accordion
      title={
        <div className={styles.header}>
          <div>
            <Text type="h6">{row.playbookCode}</Text>
          </div>

          <div className={styles.headerRight}>
            <Tag variant={row.status === 'SUCCESS' ? 'success' : 'error'}>
              {row.status}
            </Tag>
            <Text type="label">{row.createdAtLabel}</Text>
          </div>
        </div>
      }
      className={styles.playbookTracker__accordion}
      open={false}
    >
      <div className={styles.playbookTracker__card}>
        {DETAIL_SECTIONS.map((section) => (
          <div className={styles.playbookTracker__section} key={section.title}>
            <Text type="h6">{section.title}</Text>

            {section.fields.map((field) => (
              <div
                className={styles.playbookTracker__row}
                key={String(field.key)}
              >
                <Text type="label">{field.label}</Text>
                <Text classNames={styles.playbookTracker__rowValue}>
                  {getDisplayValue(row[field.key])}
                </Text>
              </div>
            ))}
          </div>
        ))}

        {formattedInput !== null && (
          <div className={styles.playbookTracker__section}>
            <div className={styles.playbookTracker__inputRow}>
              <Text type="h6">Input</Text>
              <TextArea
                value={formattedInput}
                minLines={getPayloadLines(formattedInput)}
                resize={false}
                disabled
              />
            </div>
          </div>
        )}

        {row.error ? (
          <div className={styles.playbookTracker__error}>
            <Text variant="error">{row.error}</Text>
          </div>
        ) : null}
      </div>
    </Accordion>
  );
}

export default PlaybookTrackerResultRow;
